import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  public showLoader = new Subject<any>();
  public shareLoader = this.showLoader.asObservable();

  constructor() {
    //This is intentional
   }

  setLoader(value:boolean){
    this.showLoader.next(value);
  }
}
